import { Box, styled, Typography } from "@mui/material";
import AutocompleteField from "controls/global/custom-autocomplete";
import { Signature } from "entities/UIModel/Signature";
import { useSignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  useFormContext,
  useWatch,
} from "react-hook-form";
import {
  borderRadius,
  colors,
  fontSize,
  gaps,
  margin,
} from "theme/defaultStyle";
import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";
import { useSignatures } from "utils/context/SignaturesContext";
import { IncludeAgencyConfiguration } from "utils/data/enum";

const FormField = styled("div")({
  marginTop: margin.xlarge1,
});

const InnerWrapper = styled("div")({
  display: "flex",
  gap: `${gaps.large1}`,
});

const ImageInnerWrraper = styled("div")<{ hasImage: boolean }>(({ hasImage }) => ({
  width: "272px",
  alignItems: "center",
  display: "flex",
  height: "55px",
  justifyContent: "center",
  backgroundColor: hasImage ? "transparent" : `${colors.grey10}`,
  border: `1px dashed ${hasImage ? colors.blue01 : colors.grey11}`,
  borderRadius: `${borderRadius.small}`,
}));

const SignatureImage = styled("img")({
  maxWidth: "125px",
  width: "100%",
});

const StyledAutocompleteField = styled(AutocompleteField)({
  width: "454px",
});

const StyledSignatureImageText = styled(Typography)({
  fontSize: `${fontSize.medium}`,
  color: `${colors.grey22}`,
  fontFamily: "Inter",
  textAlign: "center",
});

const FIELD_NAME = "signatureImage";

const SignatureInfo = () => {
  const [{ signatures }, {getSignature}] = useSignatures();
  const { setValue } = useFormContext();
  const [ { selectedAgency },] = useGlobalAccess();
  const [, { getAgencyLocationsByImage }] = useSignatureDefaults();
  const { mode } = useSignatureDefaultDialogProvider();
  const [imageField] = useWatch({
    name: [FIELD_NAME],
  });
  const [signatureImageData, setSignatureImageData] = useState<string>("");

  const mappedSignatures = useMemo(
    () =>
      signatures
        ?.map((signature: Signature) => ({
          text: signature.signatureImageName,
          value: signature.signatureImageID,
          integrationKey: signature.integrationKey,
        })) || [],
    [signatures],
  );

  // const getSignatureImageSource = async () => {
    
  //   const dataSoure = signatures?.find(
  //     (signature: Signature) =>
  //       signature.signatureImageID === Number(imageField?.value)
  //   )?.signatureImageData;
  //   return dataSoure;
  // };

  const getSignatureImage = async(signatureID:string, integrationKey: string) => {
    // console.log("signatureID:", signatureID);
    const signature = await getSignature(Number(signatureID), integrationKey, IncludeAgencyConfiguration.No);
    // console.log("siganture:", signature);
    setSignatureImageData(signature?.signatureImageData)
  }

  useEffect(() => {
    if (imageField?.value) {
      const integrationKey = imageField.integrationKey ||
        mappedSignatures?.find((s) => s.value === Number(imageField.value))?.integrationKey;

      if (imageField.value && integrationKey) {
        getSignatureImage(imageField.value, integrationKey);
      }
      getAgencyLocationsByImage(imageField.value,selectedAgency[0]?.CompanyID);
    }

    if(mode === "ADD") {
      setValue("agency", { text: "", value: ""});
    }
    setValue("state", { text: "", value: ""});
    if(mode === "ADD") {
      setValue("location", []);
    }
  }, [imageField?.value]);

  useEffect(() => {
    if (mappedSignatures.length === 1) {
      setValue(FIELD_NAME, {
        text: mappedSignatures[0].text,
        value: mappedSignatures[0].value,
        integrationKey: mappedSignatures[0].integrationKey,
      });
    }
  }, [mappedSignatures]);

  const onGetSignatures = async (searchText: string) => {
    const filteredSignatures = signatures?.filter((signature: Signature) =>
      signature.signatureImageName
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );

    return filteredSignatures?.map((signature: Signature) => ({
      text: signature.signatureImageName,
      value: signature.signatureImageID,
      integrationKey: signature.integrationKey,
    })) || [];
  };

  const onSignatureSelected = (selectedSignature: { text: string; value: string, integrationKey: string } | null) => {
    // console.log("selectedSignature:", selectedSignature);
    if(!selectedSignature) {
      setValue(FIELD_NAME, { text: "", value: "", integrationKey: "" });
      return;
    }
    // getSignatureImage(selectedSignature.value);
    setValue(FIELD_NAME, selectedSignature);

  };

  const renderOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: { text: string; value: string, integrationKey: string }
  ) => {
    return (
      <Box component="li" {...props} key={`${option.text} | ${option.value}}`} >
        {option.text}
      </Box>
    );
  };

  // console.log("mappedSignatures:", mappedSignatures);
  // console.log("imageField:", imageField)

  return (
    <>
      <FormField>
        <InnerWrapper>
            <StyledAutocompleteField 
              label="Signature Name"
              freeSolo={false}
              forcePopupIcon={true}
              name={FIELD_NAME}
              options={mappedSignatures}
              preferFilteredOptions={true}
              renderOption={renderOption}
              onGetOptions={onGetSignatures}
              onValueChanged={onSignatureSelected}
              getOptionLabel={(option) => option?.text}
              getOptionSelected={(option, value) => option.value === value.value}
              disabled={mappedSignatures.length === 0}
              clearOnBlur={true}
            />
            <ImageInnerWrraper hasImage={!!imageField?.text}>
              {imageField?.text && signatureImageData? 
                <SignatureImage
                src={signatureImageData} //{getSignatureImageSource()}
                alt={imageField.text}
              /> : <StyledSignatureImageText>Signature Image</StyledSignatureImageText>}
            </ImageInnerWrraper>
        </InnerWrapper>
      </FormField>
    </>
  );
};

export default SignatureInfo;
